// Storage access that never throws. In IG/FB webviews, Safari private mode,
// and cookies-blocked Chrome even reading `window.localStorage` raises
// SecurityError ("access is denied for this document") — the getter itself,
// not just getItem/setItem. Every call here is fully wrapped.

export const lsGet = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export const lsSet = (key: string, value: string): void => {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    /* storage denied or full — feature degrades, page must not crash */
  }
}

export const lsRemove = (key: string): void => {
  try {
    window.localStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

/** The Storage object itself, or null when access is denied. */
export const safeSessionStorage = (): Storage | undefined => {
  try {
    return window.sessionStorage
  } catch {
    return undefined
  }
}

export const safeLocalStorage = (): Storage | undefined => {
  try {
    return window.localStorage
  } catch {
    return undefined
  }
}
